import keyMirror from 'keymirror';

const ALERT_COLORS = keyMirror({
  warning: null,
});

export default ALERT_COLORS;
